import { IEnvironment } from './environment.interface';
import { primeuiLicense } from './primeui-license';

export const environment: IEnvironment = {
  production: false,
  apiUrl: '/api',
  sweet1AppUrl: 'https://app.sweetanalytics.com',
  appName: 'sweet-ai',
  version: '0.1.0',
  defaultLanguage: 'en',
  supportedLanguages: ['en'],
  primeuiLicense,
};
